import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _vm._t("default"),
      _vm.upload_form
        ? _c(
            VForm,
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              model: {
                value: _vm.valid,
                callback: function ($$v) {
                  _vm.valid = $$v
                },
                expression: "valid",
              },
            },
            [
              _c(
                VRow,
                [
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c(
                        VCard,
                        {
                          staticClass:
                            "min-w-0 w-full card-bulk pt-2 pb-0 mb-0",
                        },
                        [
                          _c(
                            VCol,
                            {
                              staticClass: "text-center mb-2",
                              attrs: { cols: "12" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  on: {
                                    dragover: function ($event) {
                                      $event.preventDefault()
                                    },
                                    drop: function ($event) {
                                      $event.preventDefault()
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "drag-file text-center pt-1 mt-1 pointer",
                                      on: { drop: _vm.dropFile },
                                    },
                                    [
                                      !_vm.hasFile
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex flex-column justify-space-between align-center",
                                            },
                                            [
                                              _c(VImg, {
                                                attrs: {
                                                  width: "64px",
                                                  src: require("@/assets/upload.png"),
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      !_vm.hasFile
                                        ? _c("p", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "customer_insights.bulk_upload.drag_here"
                                                )
                                              )
                                            ),
                                          ])
                                        : _vm._e(),
                                      _c(VFileInput, {
                                        staticClass:
                                          "upload-input-file pointer",
                                        attrs: {
                                          rules: _vm.rules.file,
                                          accept: ".xlsx",
                                          chips: "",
                                          placeholder: _vm.$t(
                                            "form_attrs_productize_usecase.attach_file"
                                          ),
                                          "prepend-icon": "",
                                          "show-size": "",
                                          "truncate-length": "35",
                                          solo: "",
                                          flat: "",
                                        },
                                        on: { change: _vm.onFileSelected },
                                        model: {
                                          value: _vm.form.xlsx_file,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, "xlsx_file", $$v)
                                          },
                                          expression: "form.xlsx_file",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { staticClass: "text-center" },
                    [
                      _c(
                        VBtn,
                        {
                          staticClass: "mb-3",
                          attrs: { type: "button", color: "primary" },
                          on: { click: _vm.onUpdateDictionary },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("common.upload_file")) + " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }